import React, { Component } from "react";

export default class RoomRugFilterMobileYarns extends Component {
  render() {
    return (
      <ul id="three-child-body active">
        {this.props.yarns.map((yarn) => (
          <li
            className={
              this.props.selectedYarns.indexOf(yarn.id) >= 0
                ? "three-child active"
                : "three-child"
            }
            key={"filterYarnMobile" + yarn.id + yarn.name}
            onClick={() =>
              this.props.selectHandler(yarn.id, this.props.activeFilter)
            }
          >
            <span>{yarn.name}</span>
          </li>
        ))}
      </ul>
    );
  }
}
